module.exports = __webpack_public_path__ + "static/media/user.691adf3f.svg";